const copy = {
  dropZone: "Browse for files or drag them here.",
  helpText: (maxFileSize: number): string =>
    `${maxFileSize} MB limit. Most file types accepted.`,
  label: "Attach files",
  toolTip: {
    iconTitle: "Accepted file types",
    text: (acceptedFileTypes: string[]): string =>
      `Accepted file types include: ${acceptedFileTypes.join(", ")}`,
  },
  screenReader: {
    fileDragEnter: (fileCount: number): string => `Dragging ${fileCount} files`,
    fileDragLeave: (fileCount: number): string =>
      `Cancelled dragging ${fileCount} files`,
    fileDrop: (fileCount: number): string => `Dropped ${fileCount} files`,
    fileUploading: (fileNames: string): string => `Uploading: ${fileNames}`,
    fileUploadComplete: (fileNames: string): string =>
      `Finished uploading: ${fileNames}`,
  },
  errors: {
    invalidFile: "One of your files is invalid. Please try again.",
    fileSize: (fileSize: string, maxFileSize: number): string =>
      `This file size is ${fileSize}. File must be ${maxFileSize} MB or smaller.`,
  },
};

export default copy;
